const answers = [
  { number: "01", label: "Technology and business skills" },
  { number: "02", label: "Projects and assessments" },
  { number: "03", label: "Coaching and career support" },
  { number: "04", label: "Clear program and cohort details" },
];

const HomeAnswerStripSection = () => {
  return (
    <section className="border-y border-hire-line bg-hire-tint-blue py-8 px-4">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4">
        {answers.map((answer, index) => (
          <div
            key={answer.number}
            className={`flex items-center gap-3 min-h-[54px] px-1 py-5 md:px-5 md:py-0 border-[#cfd9f0] ${
              index !== answers.length - 1 ? "border-b md:border-b-0" : ""
            } ${index !== 0 ? "md:border-l" : ""}`}
          >
            <span className="text-secondary font-poppins text-sm font-extrabold">
              {answer.number}
            </span>
            <p className="text-primary text-sm font-poppins font-bold leading-snug m-0">
              {answer.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeAnswerStripSection;
